import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from 'shared/i18n';

const GOALKEEPER = msg`Вратарь`;
const RIGHT_DEFENDER = msg`Правый защитник`;
const CENTRAL_DEFENDER = msg`Центральный защитник`;
const LEFT_DEFENDER = msg`Левый защитник`;
const RIGHT_MIDFIELDER = msg`Правый полузащитник`;
const CENTRAL_MIDFIELDER = msg`Центральный полузащитник`;
const LEFT_MIDFIELDER = msg`Левый полузащитник`;
const RIGHT_FORWARD = msg`Правый нападающий`;
const CENTRAL_FORWARD = msg`Центральный нападающий`;
const LEFT_FORWARD = msg`Левый нападающий`;

/**
 * Позиции мест в символической сборной по схеме расстановки. Ключ — значение
 * `SymbolicTeamFormation`, индекс массива — место минус один. У схемы из одного игрока (`1`)
 * подписей не было и раньше.
 */
const RANK_LABELS_BY_FORMATION: Record<string, MessageDescriptor[]> = {
  '2': [RIGHT_FORWARD, LEFT_FORWARD],
  '2-1': [RIGHT_MIDFIELDER, LEFT_MIDFIELDER, CENTRAL_FORWARD],
  '2-2': [RIGHT_MIDFIELDER, LEFT_MIDFIELDER, RIGHT_FORWARD, LEFT_FORWARD],
  '1-2-2': [GOALKEEPER, RIGHT_DEFENDER, LEFT_DEFENDER, RIGHT_FORWARD, LEFT_FORWARD],
  '1-3-2': [GOALKEEPER, RIGHT_DEFENDER, CENTRAL_DEFENDER, LEFT_DEFENDER, RIGHT_FORWARD, LEFT_FORWARD],
  '1-3-3': [GOALKEEPER, RIGHT_DEFENDER, CENTRAL_DEFENDER, LEFT_DEFENDER, RIGHT_FORWARD, CENTRAL_FORWARD, LEFT_FORWARD],
  '1-3-2-2': [
    GOALKEEPER,
    RIGHT_DEFENDER,
    CENTRAL_DEFENDER,
    LEFT_DEFENDER,
    RIGHT_MIDFIELDER,
    LEFT_MIDFIELDER,
    RIGHT_FORWARD,
    LEFT_FORWARD,
  ],
  '1-2-4-2': [
    GOALKEEPER,
    RIGHT_DEFENDER,
    LEFT_DEFENDER,
    CENTRAL_MIDFIELDER,
    CENTRAL_MIDFIELDER,
    RIGHT_MIDFIELDER,
    LEFT_MIDFIELDER,
    RIGHT_FORWARD,
    LEFT_FORWARD,
  ],
  '1-3-3-2': [
    GOALKEEPER,
    RIGHT_DEFENDER,
    CENTRAL_DEFENDER,
    LEFT_DEFENDER,
    RIGHT_MIDFIELDER,
    CENTRAL_MIDFIELDER,
    LEFT_MIDFIELDER,
    RIGHT_FORWARD,
    LEFT_FORWARD,
  ],
  '1-3-3-3': [
    GOALKEEPER,
    RIGHT_DEFENDER,
    CENTRAL_DEFENDER,
    LEFT_DEFENDER,
    RIGHT_MIDFIELDER,
    CENTRAL_MIDFIELDER,
    LEFT_MIDFIELDER,
    RIGHT_FORWARD,
    CENTRAL_FORWARD,
    LEFT_FORWARD,
  ],
  '1-4-3-2': [
    GOALKEEPER,
    RIGHT_DEFENDER,
    CENTRAL_DEFENDER,
    CENTRAL_DEFENDER,
    LEFT_DEFENDER,
    RIGHT_MIDFIELDER,
    CENTRAL_MIDFIELDER,
    LEFT_MIDFIELDER,
    RIGHT_FORWARD,
    LEFT_FORWARD,
  ],
  '1-4-4-2': [
    GOALKEEPER,
    RIGHT_DEFENDER,
    CENTRAL_DEFENDER,
    CENTRAL_DEFENDER,
    LEFT_DEFENDER,
    RIGHT_MIDFIELDER,
    CENTRAL_MIDFIELDER,
    CENTRAL_MIDFIELDER,
    LEFT_MIDFIELDER,
    RIGHT_FORWARD,
    LEFT_FORWARD,
  ],
  '1-4-3-3': [
    GOALKEEPER,
    RIGHT_DEFENDER,
    CENTRAL_DEFENDER,
    CENTRAL_DEFENDER,
    LEFT_DEFENDER,
    RIGHT_MIDFIELDER,
    CENTRAL_MIDFIELDER,
    LEFT_MIDFIELDER,
    RIGHT_FORWARD,
    CENTRAL_FORWARD,
    LEFT_FORWARD,
  ],
};

/** `rank` — с единицы, как в прежних ключах `symbolicTeam.formation_<f>.rank_<N>`. */
export function getSymbolicTeamRankLabel(formation: string, rank: number): MessageDescriptor | undefined {
  return RANK_LABELS_BY_FORMATION[formation]?.[rank - 1];
}
